import {FontAwesomeButtonEnumTypes} from "../../../components/cards/FontAwesomeButtonEnumTypes";
import {SC_WorkorderObject} from "../SC_WorkorderObject";

export class SC_ImageStatusesClone {
    static readonly ANY = 0;
    static readonly MISSING = 1;
    static readonly DAILY_REVIEW = 2;
    static readonly PENDING_FINAL_REVIEW = 3;
    static readonly FINAL_REVIEW = 4;
    static readonly COMPLIANCE_PHOTO_ERROR = 5;
    static readonly CREW_PIC_ERROR = 6;
    static readonly COMPLETE = 7;

    constructor(private flagReport: number = SC_ImageStatusesClone.ANY) { }

    static fromAPI(apiValue: number): SC_ImageStatusesClone {
        switch (Number(apiValue)) {
            case SC_ImageStatusesClone.ANY:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.ANY);
            case SC_ImageStatusesClone.MISSING:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.MISSING);
            case SC_ImageStatusesClone.DAILY_REVIEW:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.DAILY_REVIEW);
            case SC_ImageStatusesClone.PENDING_FINAL_REVIEW:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.PENDING_FINAL_REVIEW);
            case SC_ImageStatusesClone.FINAL_REVIEW:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.FINAL_REVIEW);
            case SC_ImageStatusesClone.COMPLIANCE_PHOTO_ERROR:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.COMPLIANCE_PHOTO_ERROR);
            case SC_ImageStatusesClone.CREW_PIC_ERROR:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.CREW_PIC_ERROR);
            case SC_ImageStatusesClone.COMPLETE:
                return new SC_ImageStatusesClone(SC_ImageStatusesClone.COMPLETE);
            default:
                return new SC_ImageStatusesClone();
        }
    }

    is(type: number): boolean {
        return this.flagReport === type;
    }

    toAPI(): number {
        return this.flagReport;
    }

    clone(): SC_ImageStatusesClone {
        return new SC_ImageStatusesClone(this.flagReport);
    }

    static readonly imageStatuses = [
        { key: SC_ImageStatusesClone.ANY, value: "Any" },
        { key: SC_ImageStatusesClone.MISSING, value: "Missing", className: "PicsMissing" },
        { key: SC_ImageStatusesClone.DAILY_REVIEW, value: "Daily Review", className: "PicsDaily" },
        { key: SC_ImageStatusesClone.PENDING_FINAL_REVIEW, value: "Pending Final Review", className: "PicsPFR" },
        { key: SC_ImageStatusesClone.FINAL_REVIEW, value: "Final Review", className: "PicsFR" },
        { key: SC_ImageStatusesClone.COMPLIANCE_PHOTO_ERROR, value: "Compliance Photo Error", className: "PicsPhotoError" },
        { key: SC_ImageStatusesClone.CREW_PIC_ERROR, value: "Crew Pic Error", className: "PicsCrewError" },
        { key: SC_ImageStatusesClone.COMPLETE, value: "Complete", className: "PicsComplete" },
    ];

    get className(): string {
        switch (this.flagReport) {
            case SC_ImageStatusesClone.ANY:
                return "";
            case SC_ImageStatusesClone.MISSING:
                return "PicsMissing";
            case SC_ImageStatusesClone.DAILY_REVIEW:
                return "PicsDaily";
            case SC_ImageStatusesClone.PENDING_FINAL_REVIEW:
                return "PicsPFR";
            case SC_ImageStatusesClone.FINAL_REVIEW:
                return "PicsFR";
            case SC_ImageStatusesClone.COMPLIANCE_PHOTO_ERROR:
                return "PicsPhotoError";
            case SC_ImageStatusesClone.CREW_PIC_ERROR:
                return "PicsCrewError";
            case SC_ImageStatusesClone.COMPLETE:
                return "PicsComplete";
        }
    }

    clampOnParent(wo: SC_WorkorderObject): SC_ImageStatusesClone {
        const newStatus = wo.pictureStatus();

        if (this.flagReport === SC_ImageStatusesClone.FINAL_REVIEW && newStatus.flagReport < SC_ImageStatusesClone.FINAL_REVIEW)  {
            return new SC_ImageStatusesClone(SC_ImageStatusesClone.DAILY_REVIEW);
        }

        return this;
    }

    get buttonType(): FontAwesomeButtonEnumTypes {
        return new FontAwesomeButtonEnumTypes({
            mainColor: this.className,
        });
    }

}
